require('./prerequis-conclusion.scss');

export default class PrerequisConclusionComponent {
  constructor() {
    this.controller = PrerequisConclusionController;
    this.template = require('./prerequis-conclusion.html');
    this.bindings = {
      prefix: '@',
      initialData: '<',
      onPrerequisChange: '&',
      typePersonne: '<'
    };
  }
}

class PrerequisConclusionController{
  $onInit() {
    this.data = this.initialData || {};
    this.prefix = this.prefix ? this.prefix : '';
  }

  onChange() {
    this.onPrerequisChange({prerequis: this.data});
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/prerequis/prerequis-conclusion.component.js